import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'
import { OpSupplier } from './op-supplier'


export class OpSupplierData implements IOpData {

    //#region Properties

    public idSupplierdData: number
    public idSupplier: number
    public idDataType: number
    public indexNBR: number
    public value: any

    //#endregion Properties end

    //#region NavigationProperties

    public dataType: OpDataType
    public supplier: OpSupplier

    //#endregion NavigationProperties end

    //#region CustomProperties

    //#endregion

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end

    //IOpData implementation
    public get idData() { return this.idSupplierdData }
    public set idData(idData: number) { this.idSupplierdData = idData }
    //get idDataType() { return this.idDataType }

    //get value() { return this.value }
    //IOpData implementation end

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj != null) {
            this.idSupplierdData = opObj.ID_SUPPLIER_DATA
            this.idSupplier = opObj.ID_SUPPLIER
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNBR = opObj.INDEX_NBR
            this.value = opObj.VALUE

            this.dataType = new OpDataType(opObj._DataType)
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_SUPPLIER_DATA: this.idSupplierdData,
            ID_SUPPLIER: this.idSupplier,
            ID_DATA_TYPE: this.idDataType,
            INDEX: this.indexNBR,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpSupplierData {
        const newData: OpSupplierData = new OpSupplierData(null)

        newData.idSupplierdData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNBR = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState
        return newData
    }

}